import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Download = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M20.75 15.905v3a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2v-3m8-.5v-10.5m0 10.5-3.5-3.5m3.5 3.5 3.5-3.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.75 4.155a.75.75 0 0 1 .75.75v8.69l2.219-2.22a.75.75 0 0 1 1.06 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 0 1 1.06-1.06l2.22 2.22v-8.69a.75.75 0 0 1 .75-.75m-8 11a.75.75 0 0 1 .75.75v3c0 .69.559 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-3a.75.75 0 0 1 1.5 0v3a2.75 2.75 0 0 1-2.75 2.75h-12A2.75 2.75 0 0 1 4 18.905v-3a.75.75 0 0 1 .75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
